<template>
  <v-card class="mb-8">
    <v-card-title class="primary white--text">
      <span class="white--text">Request</span>
      <v-spacer></v-spacer>
      <span>{{ request.status.toUpperCase() }}</span>
    </v-card-title>
    <v-card-text class="mt-4">
      <v-row>
        <v-col cols="12" lg="6" xl="6">
          <div class="d-flex justify-space-around black--text">
            <div>
              <span v-text="'ETA: '" class="font-weight-bold" />
              <span>
                {{ request.eta | removeTAndSecondsAndFormatDate }}
              </span>
            </div>
            <div>
              <span v-text="'ETD: '" class="font-weight-bold" />
              <span>
                {{ request.etd | removeTAndSecondsAndFormatDate }}
              </span>
            </div>
          </div> </v-col
        ><v-col cols="12" lg="6" xl="6">
          <div class="d-flex justify-space-around black--text">
            <div>
              <span v-text="'ATA: '" class="font-weight-bold" />
              <span v-if="request.ata && !isEmptyDateTimeString(request.ata)">
                {{ request.ata | removeTAndSecondsAndFormatDate }}
              </span>
              <span v-else>Not Set</span>
            </div>
            <div>
              <span v-text="'ATD: '" class="font-weight-bold" />
              <span v-if="request.atd && !isEmptyDateTimeString(request.atd)">
                {{ request.atd | removeTAndSecondsAndFormatDate }}
              </span>
              <span v-else>Not Set</span>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <!-- voyages -->
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <VoyagePlanInboundOutBoundVoyageCard
            :voyage="inboundVoyage"
            :directionString="'inbound'"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <VoyagePlanInboundOutBoundVoyageCard
            :voyage="outboundVoyage"
            :directionString="'outbound'"
          />
        </v-col>
      </v-row>
      <!-- activities -->
      <VoyagePlanActivities :planItems="requestPlanItems" />
    </v-card-text>
  </v-card>
</template>

<script>
import VoyagePlanInboundOutBoundVoyageCard from './VoyagePlanInboundOutBoundVoyageCard.vue';
import VoyagePlanActivities from './VoyagePlanActivities.vue';

export default {
  name: 'VoyagePlanRequestCard',
  components: {
    VoyagePlanActivities,
    VoyagePlanInboundOutBoundVoyageCard,
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    requestPlanItems() {
      return this.request ? this.request.planItems : null;
    },
    outboundVoyage() {
      const { voyages } = this.request;
      return voyages.find((x) => x.direction === 'outbound');
    },
    inboundVoyage() {
      const { voyages } = this.request;
      return voyages.find((x) => x.direction === 'inbound');
    },
  },
  methods: {
    isEmptyDateTimeString(value) {
      const emptyDateString = '0001-01-01T00:00:00';
      return value === emptyDateString;
    },
  },
};
</script>

<style>
</style>
